import React, { useEffect, useState } from 'react'
import Template from './ModalTemplate'
import { connect } from 'react-redux'
import { getModal } from './modalsArray'

const Modals = ({ modal }) => {
  const [, setModals] = useState({})

  useEffect(() => {
    setModals(modal)
  }, [modal])

  return (
    <>
      {Object.values(modal).map((mod) => {
        const ModalComponent = getModal(mod.id).Component
        if (mod.type !== 'minimized') {
          return (
            <Template
              // Without a key React reconciles these by position, so closing one modal can hand
              // its mounted instance (and all of its state) to a different modal that shifts
              // into the same index.
              key={mod.id}
              Component={<ModalComponent {...mod.props} />}
              title={mod.name}
              size={getModal(mod.id).size}
              modalTop={getModal(mod.id).modalTop}
              modalLeft={getModal(mod.id).modalLeft}
              minHeight={getModal(mod.id).minHeight}
              overflowY={getModal(mod.id).overflowY}
              onCloseModalClick={mod.props && mod.props.onCloseModalClick && mod.props.onCloseModalClick}
              id={mod.id}
              scrollbarWidth={getModal(mod?.id)?.scrollbarWidth}
            />
          )
        } else {
          return (
            <Template
              key={mod.id}
              Component={<ModalComponent {...mod.props} />}
              isHidden
              title={mod.name}
              size={getModal(mod.id).size}
              modalTop={getModal(mod.id).modalTop}
              modalLeft={getModal(mod.id).modalLeft}
              minHeight={getModal(mod.id).minHeight}
              overflowY={getModal(mod.id).overflowY}
              onCloseModalClick={mod.props && mod.props.onCloseModalClick && mod.props.onCloseModalClick}
              id={mod.id}
              scrollbarWidth={getModal(mod?.id)?.scrollbarWidth}
            />
          )
        }
      })}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    modal: state.GlobalModal.modals,
  }
}
export default connect(mapStateToProps, {})(Modals)
